"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.genAccount = exports.genAddingOperationsInAccount = void 0;
var prando_1 = __importDefault(require("prando"));
var bignumber_js_1 = require("bignumber.js");
var account_1 = require("@ledgerhq/coin-framework/mocks/account");
var bridge_1 = require("../bridge");
var mock_1 = __importDefault(require("../generated/mock"));
/**
 * @memberof mock/account
 */
function genAddingOperationsInAccount(account, count, seed) {
    var rng = new prando_1["default"](seed);
    var copy = __assign({}, account);
    copy.operations = Array(count)
        .fill(null)
        .reduce(function (ops) {
        var op = (0, account_1.genOperation)(copy, copy, ops, rng);
        return ops.concat(op);
    }, copy.operations);
    copy.spendableBalance = copy.balance = (0, account_1.ensureNoNegative)(copy.operations);
    var perFamilyOperation = mock_1["default"][account.currency.id];
    var postSyncAccount = perFamilyOperation && perFamilyOperation.postSyncAccount;
    if (postSyncAccount)
        postSyncAccount(copy);
    return copy;
}
exports.genAddingOperationsInAccount = genAddingOperationsInAccount;
function genAccount(id, opts) {
    if (opts === void 0) { opts = {}; }
    return (0, account_1.genAccount)(id, opts, function (account, currency, address) {
        switch (currency.family) {
            case "cosmos":
                account.cosmosResources = {
                    // TODO variation in these
                    delegations: [],
                    redelegations: [],
                    unbondings: [],
                    delegatedBalance: new bignumber_js_1.BigNumber(0),
                    pendingRewardsBalance: new bignumber_js_1.BigNumber(0),
                    unbondingBalance: new bignumber_js_1.BigNumber(0),
                    withdrawAddress: address
                };
                break;
            case "bitcoin":
                account.bitcoinResources = {
                    utxos: [],
                    walletAccount: undefined
                };
                break;
            case "polkadot":
                account.polkadotResources = {
                    stash: null,
                    controller: null,
                    nonce: 0,
                    lockedBalance: new bignumber_js_1.BigNumber(0),
                    unlockingBalance: new bignumber_js_1.BigNumber(0),
                    unlockedBalance: new bignumber_js_1.BigNumber(0),
                    unlockings: [],
                    nominations: [],
                    numSlashingSpans: 0
                };
                break;
            case "tezos":
                account.tezosResources = {
                    revealed: true,
                    counter: 0
                };
                break;
            default: {
                try {
                    var bridge = (0, bridge_1.getAccountBridge)(account);
                    var initAccount = bridge.initAccount;
                    if (initAccount) {
                        initAccount(account);
                    }
                }
                catch (e) {
                    // to fix /src/__tests__/cross.ts, skip bridge error if there is no bridge in such currency
                }
            }
        }
    }, function (account, currency, rng) {
        var perFamilyOperation = mock_1["default"][currency.id];
        var genAccountEnhanceOperations = perFamilyOperation && perFamilyOperation.genAccountEnhanceOperations;
        if (genAccountEnhanceOperations) {
            genAccountEnhanceOperations(account, rng);
        }
    });
}
exports.genAccount = genAccount;
//# sourceMappingURL=account.js.map